import { INews } from "./types"
import lessonsImage from '../assets/course8.jpg'



export const newsData : INews[] =[
    {
        title : "news.seasonTitle",
        subTitle : "news.seasonSubtitle",
        image : lessonsImage,
        content: ["news.season1", "news.season2", "news.season3", "news.season4"],
        id: "2",
        publicationDate: "2026-08-14"
    }
]


export const galleryData : INews[] =[
    {
        title : "Балетен курс „Мама и аз\"",
        subTitle : "",
        image : "" ,
        videoURL: "",
        content: [""],
        id: "1"
    }
]
